import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Forces from '../math/Forces';
import Vector2d from '../math/Vector2d';
import MouseTracker from './MouseTracker';

export default class Snowball extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x,y,vx,vy, isBig) {
    super(scene, x, y);

    this.workingWidth = 0;
    this.workingHeight = 0;

    this.sprite = null;
    this.size = 'sm';// 'sm' | 'lg'

    this.radius = 20;
    this.mass = 1.0;
    this.gravity = 820;
    this.k = 0.2;

    this.tmpForce = null;

    this.gravityForce = null;
    this.dragForce = null;
    this.frictionForce = null;
    this.totalForce = null;

    this.pos = null;
    this.vel = null;
    this.acc = null;

    this.topLimit = 0;
    this.bottomLimit = 0;
    this.leftLimit = 0;
    this.rightLimit = 0;

    this.pickedup = false;
    this.offsetX = 0;
    this.offsetY = 0;
    this.mouseTracker = null;
    this.mouseWaiter = 0;

    this.isStacked = false;

    if (isBig === true) {
      this.size = 'lg';
      this.radius = 82;
      this.mass = 10;
    }
    this.sprite = ABCyaPhaser.Images.addImage(0,0, `${this.size}Snowball`, this);
    this.workingWidth = this.sprite.width;
    this.workingHeight = this.sprite.height;

    this.topLimit = -100;
    this.leftLimit = this.radius;
    this.bottomLimit = this.scene.scale.height - 50 - this.radius;
    this.rightLimit = this.scene.scale.width - this.radius;

    this.tmpForce = new Vector2d();
    this.gravityForce = new Vector2d();
    this.dragForce = new Vector2d();
    this.frictionForce = new Vector2d();
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);

    this.totalForce = new Vector2d();

    this.k = Phaser.Math.Between(10,50) / 100;
    this.pos = new Vector2d(x,y);
    this.vel = new Vector2d(vx, vy);
    this.acc = new Vector2d();

    this.mouseTracker = new MouseTracker(this.scene);

    this.setInteractive(new Phaser.Geom.Rectangle(-this.sprite.width / 2, -this.sprite.height / 2, this.sprite.width, this.sprite.height), (hitArea, x, y, gameobject) => {
      const alpha = this.scene.textures.getPixelAlpha(x + this.sprite.width / 2, y + this.sprite.height / 2, this.sprite.texture.key, this.sprite.frame.name);
      const alphaTolerance = 1;
      return alpha && alpha >= alphaTolerance;
    });

    this.scene.input.setDraggable(this, true);
  }

  changeVel (xf,yf) {
    this.vel.x *= xf;
    this.vel.y *= yf;
  }

  update () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }

  pickup (x,y) {
    this.x = x + this.offsetX;
    this.y = y + this.offsetY;
    this.pos.reset(this.x, this.y);
    this.pickedup = true;
    this.vel.reset(0,0);
    this.mouseTracker.reset(x,y);
  }

  drag (x,y) {
    this.x = x + this.offsetX;
    this.y = y + this.offsetY;
    this.pos.reset(this.x, this.y);

    if (this.pos.y > this.bottomLimit) {
      this.pos.y = this.bottomLimit;
    }
    else if (this.pos.y < this.topLimit) {
      this.pos.y = -100;
    }
    if (this.pos.x < this.leftLimit) {
      this.pos.x = this.leftLimit;
    }
    else if (this.pos.x > this.rightLimit) {
      this.pos.x = this.rightLimit;
    }
    this.update();

    this.mouseTracker.addPoint(x,y);
    this.mouseWaiter = 0;
  }

  drop (isStill) {
    this.pickedup = false;
    if (isStill === true) {
      this.vel.reset(0,0);
    }
    else {
      const dist = this.mouseTracker.setVelocityOn(this.vel);
      if (this.size === 'lg') {
        this.vel.multiply(0.25);
      }
      if (dist > 50)ABCyaPhaser.Audio.playOneShot(`throw_${Phaser.Math.Between(1,2)}`, this.scene);
    }
  }

  trackMouse (dt) {
    if (this.mouseWaiter > 0.05) {
      this.mouseTracker.addPoint(this.pos.x, this.pos.y);
    }
    else {
      this.mouseWaiter += dt;
    }
  }

  move (dt) {
    this.pos.addScaled(this.vel, dt);
    this.angle += this.vel.x * dt;
  }

  checkForShake () {
    let value = 0;
    if (this.size === 'lg') {
      value = this.vel.y;
    }
    return value;
  }

  calcForce () {
    this.dragForce.reset(this.vel.x, this.vel.y);
    Forces.linearDrag(this.k, this.vel, this.dragForce);
    Forces.add([this.gravityForce, this.dragForce],this.totalForce);
  }

  updateAccel () {
    this.totalForce.multiply(1 / this.mass);
  }

  updateVelocity (dt) {
    this.vel.addScaled(this.totalForce, dt);
  }

  tick (dt) {
    this.calcForce();
    this.updateAccel();
    this.updateVelocity(dt);
  }
}